import React, {useEffect, useState} from "react";
import axios from "axios";
import {baseUrl} from "../Univ.js";
import {useParams} from "react-router-dom";
import "./IoTStyles.css";
function IoTLandMonitoring() {
    const {land_id} = useParams();
    const [observations, setObservations] = useState([]);
    const [loading, setLoading] = useState(false);
    // ============================================================
    // FETCH LAND IoT OBSERVATIONS
    // ============================================================
    const fetchObservations = async () => {
        try {
            setLoading(true);
            const response = await axios.get(baseUrl + "iot-land-monitoring/" + land_id + "/");
            if (Array.isArray(response.data)) {
                setObservations(response.data);
            } else if (response.data && Array.isArray(response.data.results)) {
                setObservations(response.data.results);
            } else {
                setObservations([]);
            }
        } catch (error) {
            console.log("Land IoT Error:", error);
            setObservations([]);
        } finally {
            setLoading(false);
        }
    };
    // ============================================================
    // INITIAL LOAD + LIVE REFRESH
    // ============================================================
    useEffect(() => {
        if (!land_id) {
            return;
        }
        fetchObservations();
        const interval = setInterval(fetchObservations, 5000);
        return () => clearInterval(interval);
    }, [land_id]);
    // ============================================================
    // LATEST OBSERVATION
    // ============================================================
    const latest = observations.length > 0 ? observations[0] : null;
    // ============================================================
    // HELPERS
    // ============================================================
    const getDeviceName = () => {
        if (!latest) {
            return "-";
        }
        if (latest.device_name) {
            return latest.device_name;
        }
        if (latest.device && typeof latest.device === "object") {
            return (latest.device.device_name || latest.device.device_id || "-");
        }
        return (latest.device_id || latest.device || "-");
    };
    const getCropName = () => {
        if (!latest) {
            return "-";
        }
        if (latest.crop_name) {
            return latest.crop_name;
        }
        if (latest.land_crop && typeof latest.land_crop === "object") {
            return (latest.land_crop.crop_name || latest.land_crop.crop || "-");
        }
        return latest.crop || "-";
    };
    const getLandName = () => {
        if (!latest) {
            return `Farmland ${land_id}`;
        }
        if (latest.land_name) {
            return latest.land_name;
        }
        if (latest.land && typeof latest.land === "object") {
            return (latest.land.name || latest.land.land_name || `Farmland ${land_id}`);
        }
        return (latest.land || `Farmland ${land_id}`);
    };
    return (<section className="container-fluid mt-4">


            {/* ====================================================
                HEADER
            ==================================================== */}

            <div className="iot-page-header">

                <div>

                    <h3>
                        Farmland IoT Monitoring
                    </h3>

                    <p>
                        {getLandName()}
                        {" | "}
                        Crop: {getCropName()}
                    </p>

                </div>

            </div>


            {/* ====================================================
                LOADING
            ==================================================== */}

            {loading && (<div className="text-muted mb-3">

                    Updating sensor data...

                </div>)}


            {/* ====================================================
                LATEST SENSOR VALUES
            ==================================================== */}

            {latest && (<div className="row g-3 mb-4">


                    {/* SOIL MOISTURE */}

                    <div className="col-xl-2 col-lg-3 col-md-4 col-6">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Soil Moisture
                                </small>

                                <h3>

                                    {latest.soil_moisture ?? "--"}

                                    <small>
                                        {" "}%
                                    </small>

                                </h3>

                            </div>

                        </div>

                    </div>


                    {/* SOIL TEMPERATURE */}

                    <div className="col-xl-2 col-lg-3 col-md-4 col-6">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Soil Temperature
                                </small>

                                <h3>

                                    {latest.soil_temperature ?? "--"}

                                    <small>
                                        {" "}°C
                                    </small>

                                </h3>

                            </div>

                        </div>

                    </div>


                    {/* AIR TEMPERATURE */}

                    <div className="col-xl-2 col-lg-3 col-md-4 col-6">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Air Temperature
                                </small>

                                <h3>

                                    {latest.air_temperature ?? "--"}

                                    <small>
                                        {" "}°C
                                    </small>

                                </h3>

                            </div>

                        </div>

                    </div>


                    {/* HUMIDITY */}

                    <div className="col-xl-2 col-lg-3 col-md-4 col-6">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Humidity
                                </small>

                                <h3>

                                    {latest.humidity ?? "--"}

                                    <small>
                                        {" "}%
                                    </small>

                                </h3>

                            </div>

                        </div>

                    </div>


                    {/* SOIL PH */}

                    <div className="col-xl-2 col-lg-3 col-md-4 col-6">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Soil pH
                                </small>

                                <h3>

                                    {latest.soil_ph ?? "--"}

                                </h3>

                            </div>

                        </div>

                    </div>


                    {/* RAINFALL */}

                    <div className="col-xl-2 col-lg-3 col-md-4 col-6">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Rainfall
                                </small>

                                <h3>

                                    {latest.rainfall ?? "--"}

                                    <small>
                                        {" "}mm
                                    </small>

                                </h3>

                            </div>

                        </div>

                    </div>


                    {/* LIGHT */}

                    <div className="col-xl-2 col-lg-3 col-md-4 col-6">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Light Intensity
                                </small>

                                <h3>

                                    {latest.light_intensity ?? "--"}

                                    <small>
                                        {" "}lux
                                    </small>

                                </h3>

                            </div>

                        </div>

                    </div>


                    {/* NITROGEN */}

                    <div className="col-xl-2 col-lg-3 col-md-4 col-6">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Nitrogen
                                </small>

                                <h3>

                                    {latest.nitrogen ?? "--"}

                                    <small>
                                        {" "}mg/kg
                                    </small>

                                </h3>

                            </div>

                        </div>

                    </div>


                    {/* PHOSPHORUS */}

                    <div className="col-xl-2 col-lg-3 col-md-4 col-6">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Phosphorus
                                </small>

                                <h3>

                                    {latest.phosphorus ?? "--"}

                                    <small>
                                        {" "}mg/kg
                                    </small>

                                </h3>

                            </div>

                        </div>

                    </div>


                    {/* POTASSIUM */}

                    <div className="col-xl-2 col-lg-3 col-md-4 col-6">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Potassium
                                </small>

                                <h3>

                                    {latest.potassium ?? "--"}

                                    <small>
                                        {" "}mg/kg
                                    </small>

                                </h3>

                            </div>

                        </div>

                    </div>

                </div>)}


            {/* ====================================================
                DEVICE INFORMATION
            ==================================================== */}

            {latest && (<div className="card shadow-sm mb-4">

                    <div className="card-header">

                        <strong>
                            IoT Device
                        </strong>

                    </div>


                    <div className="card-body">

                        <div className="row">


                            <div className="col-md-3">

                                <small className="text-muted">
                                    Device
                                </small>

                                <div>
                                    {getDeviceName()}
                                </div>

                            </div>


                            <div className="col-md-3">

                                <small className="text-muted">
                                    Farmland
                                </small>

                                <div>
                                    {getLandName()}
                                </div>

                            </div>


                            <div className="col-md-3">

                                <small className="text-muted">
                                    Crop
                                </small>

                                <div>
                                    {getCropName()}
                                </div>

                            </div>


                            <div className="col-md-3">

                                <small className="text-muted">
                                    Last Recorded
                                </small>

                                <div>
                                    {latest.recorded_at || "-"}
                                </div>

                            </div>

                        </div>

                    </div>

                </div>)}


            {/* ====================================================
                OBSERVATION HISTORY
            ==================================================== */}

            <div className="card shadow-sm">

                <div className="card-header">

                    <strong>
                        Sensor Observation History
                    </strong>

                </div>


                <div className="card-body">

                    <div className="table-responsive">

                        <table className="table table-hover">

                            <thead>

                            <tr>

                                <th>
                                    Time
                                </th>

                                <th>
                                    Soil Moisture
                                </th>

                                <th>
                                    Soil Temp.
                                </th>

                                <th>
                                    Air Temp.
                                </th>

                                <th>
                                    Humidity
                                </th>

                                <th>
                                    Soil pH
                                </th>

                                <th>
                                    Rainfall
                                </th>

                                <th>
                                    Light
                                </th>

                                <th>
                                    N
                                </th>

                                <th>
                                    P
                                </th>

                                <th>
                                    K
                                </th>

                            </tr>

                            </thead>


                            <tbody>

                            {observations.length === 0 ? (<tr>

                                    <td
                                        colSpan="11"
                                        className="text-center text-muted"
                                    >

                                        No sensor observations
                                        available.

                                    </td>

                                </tr>) : (observations.map(observation => (<tr
                                        key={observation.id}
                                    >

                                        <td>
                                            {observation.recorded_at}
                                        </td>


                                        <td>

                                            {observation.soil_moisture ?? "--"}
                                            %

                                        </td>


                                        <td>

                                            {observation.soil_temperature ?? "--"}
                                            °C

                                        </td>


                                        <td>

                                            {observation.air_temperature ?? "--"}
                                            °C

                                        </td>


                                        <td>

                                            {observation.humidity ?? "--"}
                                            %

                                        </td>


                                        <td>

                                            {observation.soil_ph ?? "--"}

                                        </td>


                                        <td>

                                            {observation.rainfall ?? "--"}
                                            mm

                                        </td>


                                        <td>

                                            {observation.light_intensity ?? "--"}

                                        </td>


                                        <td>

                                            {observation.nitrogen ?? "--"}

                                        </td>


                                        <td>

                                            {observation.phosphorus ?? "--"}

                                        </td>


                                        <td>

                                            {observation.potassium ?? "--"}

                                        </td>

                                    </tr>)))}

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </section>);
}
export default IoTLandMonitoring;
